import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import WareHouse from '../entities/warehouse'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface WareHouseState extends ListState<WareHouse>{
    editWareHouse:WareHouse
}
class UserMutations extends ListMutations<WareHouse>{

}
class WareHouseModule extends ListModule<WareHouseState,any,WareHouse>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<WareHouse>(),
        filterlist:new Array<WareHouse>(),
        loading:false,
        editWareHouse:new WareHouse()
    }
    actions={
        async GetPaged(context:ActionContext<WareHouseState,any>,payload:any){
          
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Warehouse/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<WareHouse>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
        },
        async getAll(context:ActionContext<WareHouseState,any>,payload:any){
          //debugger;
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/Warehouse/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<WareHouse>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
            context.state.filterlist=page.items;
            return 1;
        },
        async RegetAll(context:ActionContext<WareHouseState,any>,payload:any){
            //debugger;
              context.state.loading=true;
              let reponse=await Ajax.get('/api/services/app/Warehouse/GetAll',{params:payload.data});
              context.state.loading=false;
              let page=reponse.data.result as PageResult<WareHouse>;
              context.state.totalCount=page.totalCount;
            //   context.state.list=page.items;
            //   context.state.filterlist=page.items;
              return page.items;
          },
        async getfilter(context:ActionContext<WareHouseState,any>,payload:any){
            //debugger;
              context.state.loading=true;
              let reponse=await Ajax.get('/api/services/app/Warehouse/GetAll',{params:payload.data});
              context.state.loading=false;
              let page=reponse.data.result as PageResult<WareHouse>;
              context.state.totalCount=page.totalCount;
              context.state.filterlist=page.items;
              return 1;
          },
        async create(context:ActionContext<WareHouseState,any>,payload:any){
            await Ajax.post('/api/services/app/Warehouse/Create',payload.data);
        },
        async update(context:ActionContext<WareHouseState,any>,payload:any){
            await Ajax.put('/api/services/app/Warehouse/Update',payload.data);
        },
        async delete(context:ActionContext<WareHouseState,any>,payload:any){
            await Ajax.delete('/api/services/app/Warehouse/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<WareHouseState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/Warehouse/GetById?Id='+payload.id);
            return reponse.data.result as WareHouse;
        }
    };
    mutations={
        setCurrentPage(state:WareHouseState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:WareHouseState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:WareHouseState,warehouse:WareHouse){
            state.editWareHouse=warehouse;
        }
    }
}
const warehouseModule=new WareHouseModule();
export default warehouseModule;